// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__QsG6_","dragIcon":"Choice_dragIcon__1qiuB","left":"Choice_left__24Qkc","input":"Choice_input__3cUDs"};